<template>
  <!-- Baby Admin Start -->
  <div class="product-baby-admin">
    <div class="baby-admin">
      <div class="admin__content">
        <div class="content__title" data-aos="fade-up" :data-aos-duration="duration">
          <span>{{$t('baby.admin.title')}}</span>
        </div>
        <div class="content__sub-title" data-aos="fade-up" :data-aos-duration="duration">
          <span v-html="$t('baby.admin.sub-title')"></span>
          <span class="sub-title__exp">{{$t('baby.admin.sub-title-exp')}}</span>
        </div>
      </div>
    </div>
    <div class="admin__image" data-aos="fade-up" :data-aos-duration="duration">
      <!-- language check -->
      <template v-if="this.$i18n.locale() === 'ko'">
        <!-- ** lang KO Start ** -->
        <swiper ref="mySwiper" class="swiper no-drag" :options="swiperOption">
          <swiper-slide>
            <div class="slide__item">
              <img src="../../assets/img/img_baby_admin_1_ko.png" alt="admin"/>
              <span class="admin__image__text--ko">{{$t('baby.admin.dashboard')}}</span>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="slide__item">
              <img src="../../assets/img/img_baby_admin_2_ko.png" alt="admin"/>
              <span class="admin__image__text--ko">{{$t('baby.admin.monitoring')}}</span>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="slide__item">
              <img src="../../assets/img/img_baby_admin_3_ko.png" alt="admin"/>
              <span class="admin__image__text--ko">{{$t('baby.admin.history')}}</span>
            </div>
          </swiper-slide>
        </swiper>
        <div class="swiper-pagination" slot="pagination"></div>
        <!-- ** lang KO End ** -->
      </template>
      <template v-else>
        <!-- ** lang EN Start ** -->
        <swiper ref="mySwiper" class="swiper no-drag" :options="swiperOption">
          <swiper-slide>
            <div class="slide__item">
              <img src="../../assets/img/img_baby_admin_1_en.png" alt="admin"/>
              <span>{{$t('baby.admin.dashboard')}}</span>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="slide__item">
              <img src="../../assets/img/img_baby_admin_2_en.png" alt="admin"/>
              <span>{{$t('baby.admin.monitoring')}}</span>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="slide__item">
              <img src="../../assets/img/img_baby_admin_3_en.png" alt="admin"/>
              <span>{{$t('baby.admin.history')}}</span>
            </div>
          </swiper-slide>
        </swiper>
        <div class="swiper-pagination" slot="pagination"></div>
        <!-- ** lang EN Start ** -->
      </template>
    </div>

  </div>
  <!-- Baby Admin End -->
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import { FadeUpMixin } from '../mixins/FadeUp';
import 'swiper/css/swiper.css';

export default {
  name: 'BabyAdmin',
  components: {
    Swiper,
    SwiperSlide,
  },
  created() {
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: 'auto',
        centeredSlides: true,
        spaceBetween: 0,
        loop: true,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      },
    };
  },
  mixins: [FadeUpMixin],
  methods: {
  },
};
</script>

<style lang="scss" scoped>
  @import '../../assets/scss/constant';
  @import '../../assets/scss/mixins';

  /* ------------------
    :: Product Baby Admin CSS
    ------------------ */
  .product-baby-admin {
    padding: 116px 0;
    @include flexbox;
    @include flex-direction(column);
    @include align-items(center);

    .content {
      &__title {
        color: $color-pink;
      }
    }
  }

  .baby-admin {
    width: 100%;
    max-width: 1578px;
    padding: 0 30px;
  }

  .admin__image {
    overflow: hidden;
    @include flexbox;
    @include flex-direction(column);
    @include align-items(center);
    margin-top: 10px;

    .swiper {
      width: 70%;

      /deep/
      &-wrapper {
        height: fit-content;
        flex-shrink: 0;
      }

      /deep/
      &.swiper-container {
        overflow: visible;
      }

      /deep/
      &-slide {
        @include flexbox;
        @include justify-content(center);
        max-width: 1200px;

        img {
          width: 100%;
          max-width: 1200px;
          max-height: 700px;
          flex-shrink: 0;
        }
        span {
          position: absolute;
          left: 0;
          top: 13%;
          -ms-writing-mode: tb-lr;
          writing-mode: vertical-lr;
          transform: rotate(180deg);
          font-size: 16px;
          color: $color-black;

          &.admin__image__text--ko {
            left: -7%;
            top: 18%;

            writing-mode: inherit;
            -webkit-transform: rotate(-90deg);
            -ms-transform: rotate(-90deg);
            transform: rotate(-90deg);

            &.item--last {
              margin-left: -8px;
            }
          }
        }
      }

      /deep/
      &-pagination {
        position: relative;
        margin-top: 28px;
        &-bullet {
          width: 12px;
          height: 12px;
          background-color: $color-header-gray;
          opacity: 1;
          outline: none;
          margin: 5px;

          &-active {
            background-color: $color-pink;
          }
        }
      }
    }
  }

  // IE Only
  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    .product-baby-admin {
      overflow: hidden;
    }
    .admin__image {
      .swiper {
        /deep/
        &.swiper-container {
          overflow: hidden;
        }
      }
    }
  }

  @media (min-width: 576px) {
    .admin__image {
      .swiper {
        &-slide {
          span.admin__image__text--ko {
            left: -4%;
            top: 13%;
          }
        }
      }
    }
  }

  @media (min-width: 768px) {
    .admin__image {
      margin-top: 97px;
      .swiper {
        width: 60%;

        &-slide {
          span {
            left: 4%;
            &.admin__image__text--ko {
              left: 0;
            }
          }
        }
      }
    }
  }

  @media (min-width: 992px) {
    .admin__image {
      .swiper {
        &-slide {
          span.admin__image__text--ko {
            left: 2%;
          }
        }
      }
    }
  }

</style>
